/* eslint-disable no-undef */
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		CENTRA_CHECKOUT_SECRET: z.string().min(1),
		PREVIEW_TOKEN: z.string().min(1),
		REVALIDATE_SECRET: z.string().min(1),
		STORYBLOK_PREVIEW_TOKEN: z.string().min(1),
		STORYBLOK_SPACE_ID: z.string().min(1),
		CENTRA_INTEGRATION_TOKEN: z.string().min(1),
		RULE_API_KEY: z.string().min(1),
		POSTMARK_SERVER_TOKEN: z.string().min(1),
		CUSTOMER_SERVICE_FROM_EMAIL: z.string().email(),
		CUSTOMER_SERVICE_TO_EMAIL: z.string().email(),
	},
	client: {
		NEXT_PUBLIC_CENTRA_CHECKOUT: z.string().url(),
		NEXT_PUBLIC_CENTRA_INTEGRATION_URL: z.string().url(),
		NEXT_PUBLIC_CENTRA_DOMAIN: z.string().min(1),
		NEXT_PUBLIC_PROJECT: z.string().min(1),
		NEXT_PUBLIC_HYPERDX_KEY: z.string().min(1),
		NEXT_PUBLIC_FREND_ADDRESS_KEY: z.string().min(1),
		NEXT_PUBLIC_DEPICT_API_URL: z.string().url(),
		NEXT_PUBLIC_DEPICT_MERCHANT: z.string().min(1),
		NEXT_PUBLIC_GTM_ID: z.string().min(1),
	},
	experimental__runtimeEnv: {
		NEXT_PUBLIC_CENTRA_CHECKOUT: process.env.NEXT_PUBLIC_CENTRA_CHECKOUT,
		NEXT_PUBLIC_CENTRA_INTEGRATION_URL: process.env.NEXT_PUBLIC_CENTRA_INTEGRATION_URL,
		NEXT_PUBLIC_CENTRA_DOMAIN: process.env.NEXT_PUBLIC_CENTRA_DOMAIN,
		NEXT_PUBLIC_PROJECT: process.env.NEXT_PUBLIC_PROJECT,
		NEXT_PUBLIC_HYPERDX_KEY: process.env.NEXT_PUBLIC_HYPERDX_KEY,
		NEXT_PUBLIC_FREND_ADDRESS_KEY: process.env.NEXT_PUBLIC_FREND_ADDRESS_KEY,
		NEXT_PUBLIC_DEPICT_API_URL: process.env.NEXT_PUBLIC_DEPICT_API_URL,
		NEXT_PUBLIC_DEPICT_MERCHANT: process.env.NEXT_PUBLIC_DEPICT_MERCHANT,
		NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
	},
	onValidationError: (error) => {
		console.error(error);
		throw new Error(`Invalid envorinment: ${JSON.stringify(error, null, 2)}`);
	},
});
